import { useIntl } from 'react-intl';

import { FontSizes, FontWeights } from '@calm-web/design-system';

import messages from '@/components/PreSignupFlow/Components/PaymentDetailsModal/messages';

import { useSisu } from '../../Provider';
import { ConfirmButton, Copy } from './styles';

export type PaymentDetailsModalProps = {
	onCloseClick: () => void;
};

export default function HelpModal({ onCloseClick }: PaymentDetailsModalProps) {
	const { selectedSku } = useSisu();
	const { formatMessage } = useIntl();

	let trialLength: string | undefined;
	if (selectedSku?.trialDuration?.months) {
		trialLength = formatMessage(messages.trialMonths, {
			number: selectedSku?.trialDuration.months,
		});
	} else if (selectedSku?.trialDuration?.days) {
		trialLength = formatMessage(messages.trialDays, {
			number: selectedSku?.trialDuration.days,
		});
	}

	return (
		<div role="dialog">
			<Copy el="p" color="gray7" size={FontSizes.base} weight={FontWeights.Light}>
				{formatMessage(messages.trialInfo, { trialLength })}
			</Copy>
			<Copy el="p" color="gray7" size={FontSizes.base} weight={FontWeights.Light}>
				{formatMessage(messages.cancel, { trialLength })}
			</Copy>
			<ConfirmButton backgroundColor="blue2" onPress={onCloseClick}>
				{formatMessage(messages.confirmButtonCta)}
			</ConfirmButton>
		</div>
	);
}
